export default{
  talentTrainServe:{
    Button:{
      lookDetail:"查看详情"
    },
    talentTrain:{
      title:"人才及培训服务",
      subtitle:"致力于为相关领域的企业提供全方位的人才支持与技能提升解决方案",
      desc:"在全球贸易的快速发展中，人才与技术的核心竞争力决定了企业的未来。全球商通中心人才及培训服务版块汇聚全球顶尖专家，提供定制化培训课程， 帮助企业培养高素质人才、掌握先进技术，从而提升生产效率、优化供应链管理，并在国际市场中占据领先地位。",
      list:[{name:"全球专家库",desc:"涵盖农业科学、供应链管理、国际贸易等领域的顶尖专家。"},
      {name:"定制化培训",desc:"根据企业需求设计专属培训方案，提升员工专业技能。"},{name:"认证服务",desc:"完成培训后可获得全球认可的证书，提升企业人才竞争力。"}]
    },
    TrainService:{
      title:"培训服务",
      list:[
        {name:"国际业务培训",desc:"为企业管理层提供成本管理及流程优化的实战训练，旨在增强企业在国际化背景下的智慧经营决策能力。"},
        {name:"专业技能培训",desc:"覆盖岗位技能认证+行业技术仿真训练，构建标准化人才能力评价体系。"},
        {name:"政策解读",desc:"深入剖析国家发布的各项农业相关政策，通过详细的解读与分析帮助农民、农业从业者及相关利益方更好地理解和应用相关政策。"},
        {name:"农村电商",desc:"农产品网销全流程解析：从直播运营到冷链物流，激活县域经济新动能。"},
      ]
    },
    TrainCatg:{
      list:[
        {name:"组织“产业链”培训",desc:"“新六产”发展模式催生产业链相加、价值链相乘，牵引中国农业发展进入新高地，学院及时组织“产业链”上搞培训，产业延伸到哪里，培训就跟进到哪里，发挥产业培训精准性。"},
        {name:"实施“走出去”培训",desc:'立足潍坊，辐射全球，以县域为单位组建培训学校和科技服务站，旨在发挥学院平台优势和当地资源优势，为乡村振兴提供人才支撑。'},
        {name:"实施“请进来”培训",desc:'承接农业龙头企业、农民合作社、家庭农场、现代农业产业园、生态种植园、农业休闲观光园、农村党组织建设、乡村振兴、乡土文化与旅游培训和参观考察。'},
        {name:"创新培训模式赋能乡村振兴",desc:"突出潍坊优势产业培训，先后开展了“潍县萝卜”“寒亭西瓜”“昌邑大姜”“临朐樱桃”等为代表的产业培训班72期。"},
        {name:"参观考察",desc:"提供实地学习与交流的机会，帮助参与者深入了解行业前沿技术、管理模式和成功案例。"},
        {name:"农业经理人培训",desc:"承接全省 “农业经理人培训”任务。培训共分4期每期9天时间，全省500名农业经理人参加了培训。"},
      ]
    },
    
  }
  
}